var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 144,
    viewBox: "0 0 161 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_8185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.831 4H41.944L3 71.453L41.944 138.905H119.831L158.774 71.453L119.831 4Z",
    fill: "#FF826C",
    stroke: "#EAEAEA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5 98L97.5076 60.0471L95.2074 63.2848L76.9226 45L75.3342 80.602L71.1477 76.4155L56.5 84.5L51.5 78.5L44.9999 80.602L44.0995 79.7016L36.5 79L118.5 136.5C125 125 131.5 113.5 140.5 98Z",
    fill: "#E96149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 53.1811H36.8189V53C36.8189 53 36.8189 52 36.5 52C36.1811 52 36.1811 53 36.1811 53V53.1811H36C36 53.1811 35 53.1811 35 53.5C35 53.8189 36 53.8189 36 53.8189H36.1811V54C36.1811 54 36.1811 55 36.5 55C36.8189 55 36.8189 54 36.8189 54V53.8189H37C37 53.8189 38 53.8189 38 53.5C38 53.1811 37 53.1811 37 53.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 18.5,
    r: 2.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 116.5,
    r: 1.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 99,
    r: 1.75,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 70.5,
    r: 2.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9458 26.3301H61.5885V25.9728C61.5885 25.9728 61.5885 24 60.9593 24C60.3301 24 60.3301 25.9728 60.3301 25.9728V26.3301H59.9728C59.9728 26.3301 58 26.3301 58 26.9593C58 27.5884 59.9728 27.5885 59.9728 27.5885H60.3301V27.9457C60.3301 27.9457 60.3301 29.9186 60.9593 29.9186C61.5885 29.9186 61.5885 27.9457 61.5885 27.9457V27.5885H61.9457C61.9457 27.5885 63.9186 27.5884 63.9186 26.9593C63.9186 26.3301 61.9458 26.3301 61.9458 26.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.667 94.1653H134.335V93.8333C134.335 93.8333 134.335 92 133.75 92C133.165 92 133.165 93.8333 133.165 93.8333V94.1653H132.833C132.833 94.1653 131 94.1653 131 94.75C131 95.3346 132.833 95.3347 132.833 95.3347H133.165V95.6667C133.165 95.6667 133.165 97.5 133.75 97.5C134.335 97.5 134.335 95.6667 134.335 95.6667V95.3347H134.667C134.667 95.3347 136.5 95.3347 136.5 94.75C136.5 94.1653 134.667 94.1653 134.667 94.1653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.333 52.1496H127.85V51.6666C127.85 51.6666 127.85 49 127 49C126.15 49 126.15 51.6666 126.15 51.6666V52.1496H125.667C125.667 52.1496 123 52.1496 123 53C123 53.8504 125.667 53.8504 125.667 53.8504H126.15V54.3334C126.15 54.3334 126.15 57 127 57C127.85 57 127.85 54.3334 127.85 54.3334V53.8504H128.333C128.333 53.8504 131 53.8504 131 53C131 52.1495 128.333 52.1496 128.333 52.1496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.567 31.5157H112.334V31.2833C112.334 31.2833 112.334 30 111.925 30C111.516 30 111.516 31.2833 111.516 31.2833V31.5157H111.283C111.283 31.5157 110 31.5157 110 31.925C110 32.3342 111.283 32.3343 111.283 32.3343H111.516V32.5667C111.516 32.5667 111.516 33.85 111.925 33.85C112.334 33.85 112.334 32.5667 112.334 32.5667V32.3343H112.567C112.567 32.3343 113.85 32.3343 113.85 31.925C113.85 31.5157 112.567 31.5157 112.567 31.5157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6667 126.756H64.2441V126.333C64.2441 126.333 64.2441 124 63.5 124C62.7559 124 62.7559 126.333 62.7559 126.333V126.756H62.3333C62.3333 126.756 60 126.756 60 127.5C60 128.244 62.3333 128.244 62.3333 128.244H62.7559V128.667C62.7559 128.667 62.7559 131 63.5 131C64.2441 131 64.2441 128.667 64.2441 128.667V128.244H64.6667C64.6667 128.244 67 128.244 67 127.5C67 126.756 64.6667 126.756 64.6667 126.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.333 123.968H110.032V123.667C110.032 123.667 110.032 122 109.5 122C108.968 122 108.968 123.667 108.968 123.667V123.968H108.667C108.667 123.968 107 123.968 107 124.5C107 125.031 108.667 125.032 108.667 125.032H108.968V125.333C108.968 125.333 108.968 127 109.5 127C110.032 127 110.032 125.333 110.032 125.333V125.032H110.333C110.333 125.032 112 125.032 112 124.5C112 123.968 110.333 123.968 110.333 123.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.28 82.1181H31.8019V81.64C31.8019 81.64 31.8019 79 30.96 79C30.1181 79 30.1181 81.64 30.1181 81.64V82.1181H29.64C29.64 82.1181 27 82.1181 27 82.96C27 83.8019 29.64 83.8019 29.64 83.8019H30.1181V84.28C30.1181 84.28 30.1181 86.92 30.96 86.92C31.8019 86.92 31.8019 84.28 31.8019 84.28V83.8019H32.28C32.28 83.8019 34.92 83.8019 34.92 82.96C34.92 82.118 32.28 82.1181 32.28 82.1181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.462 70.4199L95.2097 108H66.7227L71.4704 70.4199H90.462Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4632 70.4199H80.7969V108H95.2109L90.4632 70.4199Z",
    fill: "#FFDD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4741 88.0312C43.4741 78.8577 34 78.5571 34 78.5571C43.1735 78.5571 43.4741 69.083 43.4741 69.083C43.4741 78.2565 52.9482 78.5571 52.9482 78.5571C43.7747 78.5571 43.4741 88.0312 43.4741 88.0312Z",
    fill: "#FFDD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4727 69.083C43.4727 78.2565 52.9467 78.5571 52.9467 78.5571C43.7733 78.5571 43.4727 88.0312 43.4727 88.0312V69.083Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.216 79.8945C123.216 70.721 113.742 70.4204 113.742 70.4204C122.916 70.4204 123.216 60.9463 123.216 60.9463C123.216 70.1197 132.69 70.4204 132.69 70.4204C123.517 70.4201 123.216 79.8945 123.216 79.8945Z",
    fill: "#FFDD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.215 60.9463C123.215 70.1197 132.689 70.4204 132.689 70.4204C123.515 70.4204 123.215 79.8945 123.215 79.8945V60.9463Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6381 30.2044L91.9793 43.9881C92.5806 45.1164 93.6666 45.906 94.9256 46.1288L110.303 48.8511C113.582 49.4319 114.884 53.4375 112.573 55.8349L101.732 67.0759C100.844 67.9962 100.43 69.2733 100.606 70.5397L102.769 86.0066C103.23 89.3046 99.8225 91.7807 96.8286 90.3227L82.7877 83.4859C81.6381 82.9263 80.2953 82.9263 79.1456 83.4859L65.105 90.3227C62.1112 91.7807 58.7029 89.3046 59.1646 86.0066L61.3272 70.5397C61.5043 69.2736 61.089 67.9959 60.2016 67.0756L49.361 55.8346C47.0492 53.4372 48.351 49.431 51.6303 48.8508L67.008 46.1285C68.2667 45.9057 69.3534 45.1161 69.9544 43.9878L77.2955 30.2041C78.8605 27.2652 83.0729 27.2652 84.6381 30.2044Z",
    fill: "#FFDD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.573 55.835C114.885 53.4382 113.583 49.432 110.303 48.8512L94.9257 46.1289C93.6671 45.9061 92.5804 45.1165 91.9794 43.9882L84.6389 30.2046C83.8252 28.677 82.2971 27.9507 80.7969 28.0113V83.0761C81.4766 83.0485 82.161 83.181 82.7884 83.4864L96.829 90.3231C99.8229 91.7811 103.231 89.305 102.77 86.007L100.607 70.5402C100.43 69.274 100.845 67.9964 101.732 67.076L112.573 55.835Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_8185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.774,
    height: 143.01,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.5b6a5e91.svg";
export { ForwardRef as ReactComponent };